import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const without = ['Drills, not sessions — you still build the class', 'No order: what to teach first is still on you', 'One version for everyone on the court', 'Lines of players waiting for their turn', 'Repetition without correction'];
const withIt = ['136 Session Cards, each a complete lesson or clinic', 'Skills in the order they build, first class to full season', 'Level Ladder on every drill: easier, on-level, harder', 'Rotation Grid for 2 to 16+ — everyone hitting', 'Coach’s Eye and error → fix on every card'];
export function ValueStack() {
  return <section aria-labelledby="vs-heading" className="w-full bg-navy" data-id="element-277" data-mp="296pab0k83rgi">
      <div className="max-w-4xl mx-auto px-5 py-16 sm:py-20" data-id="element-278" data-mp="2d7r2ixfq338z">
        <div className="text-center" data-id="element-279" data-mp="30yeqes61a3h6">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-280" data-mp="30xbxkep5hqym">
            Why this isn&apos;t another drill book
          </p>
          <h2 id="vs-heading" className="mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-281" data-mp="1tfcwex493bvn">
            A drill list vs{' '}
            <span className="text-gold" data-id="element-282" data-mp="1oe72ivyutikj">a session system</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-ink-soft" data-id="element-283" data-mp="235y1n3efjenj">
            Free videos and drill books give you more drills. Drills were never
            the problem — knowing what to run tomorrow, in what order, for
            whoever shows up, was.
          </p>
        </div>

        {/* Two columns at every width — never stacks */}
        <div className="mt-8 grid grid-cols-2 overflow-hidden rounded-2xl border border-navy-line" data-id="element-284" data-mp="2m40pvfz5l7ka">
          <div className="bg-navy-mid px-3.5 py-4 sm:p-6" data-id="element-285" data-mp="2h577pa8x8sds">
            <h3 className="font-display text-base uppercase tracking-wide text-ink-soft sm:text-xl" data-id="element-286" data-mp="2h5qqet6ebksv">
              Free drills &amp; drill books
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-287" data-mp="mrpuoh657dx0">
              {without.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] leading-snug text-ink-soft sm:text-sm" data-id="element-288" data-mp="2mtpas64wwp4z">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-crimson/15" data-id="element-289" data-mp="2vtu8tpo7ub6h">
                    <XIcon className="h-2.5 w-2.5 text-crimson-deep" aria-hidden="true" data-id="element-290" data-mp="30tgmu1bvbvgc" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="bg-gold/10 px-3.5 py-4 text-white sm:p-6" data-id="element-291" data-mp="3aqbjsfshtnsi">
            <h3 className="font-display text-base uppercase tracking-wide text-gold sm:text-xl" data-id="element-292" data-mp="3fhtjz1mozkcf">
              Court Ready
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-293" data-mp="3jidia8j04u05">
              {withIt.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] font-medium leading-snug sm:text-sm" data-id="element-294" data-mp="3ojayifkgbdz0">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-gold/20" data-id="element-295" data-mp="7g5elrec1cr8">
                    <CheckIcon className="h-2.5 w-2.5 text-gold-hover" aria-hidden="true" data-id="element-296" data-mp="2gixv7zapedo" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}